import React, {useEffect, useState} from "react";
import {
    Box,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableRow,
    TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import Button from "react-bootstrap/Button";
import moment from 'moment'
import {toast} from "react-toastify";
import {changeAhtabotSubscriptionBillingTypeToChoosenTypeFromUiUrl, connectionErrorMessage} from "../../data";
import {useCookies} from "react-cookie";
import NumberFormat from "react-number-format";

const WARNING_BEFORE_DATE_MSG = "Üyelik Bitiş Tarihi, Günün Tarihi ile Aynı veya Günün Tarihinden Geri Olamaz!";
const WARNING_EMPTY_FILE_COUNT_MSG = "Lütfen İşlem Yapılacak Dosya Sayısını Giriniz!";
const WARNING_MIN_FILE_COUNT_MSG = "Dosya Sayısı 500 Dosyanın Altında Olamaz!";

function MembershipModalDialog({openDialog, handleCloseDialog, ahtapotRequestDto, getDataTenantList, changeTenantId, selectionModel, currentBillingTypeEnumValue, remainingDayCount}) {
    const todayStr = new Date().toISOString().split("T")[0];

    const canCarryOver = currentBillingTypeEnumValue !== "PRESALE_DEMO";
    const carriedOverDayCount = canCarryOver ? Math.max(0, Number(remainingDayCount) || 0) : 0;

    const [cookies] = useCookies(['subscriptionToken']);
    const [membershipType, setMembershipType] = useState("PRESALE_FIXED");
    const [fileCount, setFileCount] = useState("");
    const [dayCount, setDayCount] = useState("");
    const [endDate, setEndDate] = useState("");
    const [lastModifiedDate, setLastModifiedDate] = useState(todayStr);
    const [paymentAmount, setPaymentAmount] = useState("0");
    const [userInput, setUserInput] = useState("");
    const [addCarriedDaysFixed, setAddCarriedDaysFixed] = useState(false);

    const isFixed = membershipType === "PRESALE_FIXED";
    const showFixedCarry = isFixed && addCarriedDaysFixed && carriedOverDayCount > 0;
    const fixedTotalDays = Number(dayCount) || 0;
    const fixedAdditionalDays = Math.max(0, fixedTotalDays - carriedOverDayCount);

    useEffect(() => {
        setEndDate(todayStr);
    }, [todayStr]);

    useEffect(() => {
        setAddCarriedDaysFixed(false);
        setFileCount("0");
    }, [membershipType]);

    useEffect(() => {
        const today = new Date();

        if (membershipType === "PRESALE_YEAR") {
            today.setFullYear(today.getFullYear() + 1);
            today.setDate(today.getDate() + carriedOverDayCount);
            setEndDate(today.toISOString().split("T")[0]);
        } else if (membershipType === "PRESALE_QUARTER") {
            today.setMonth(today.getMonth() + 3);
            today.setDate(today.getDate() + carriedOverDayCount);
            setEndDate(today.toISOString().split("T")[0]);
        } else if (membershipType === "PRESALE_FIXED") {
            if (addCarriedDaysFixed) {
                today.setDate(today.getDate() + carriedOverDayCount);
            }
            setEndDate(today.toISOString().split("T")[0]);
        }
    }, [membershipType, carriedOverDayCount, addCarriedDaysFixed]);

    useEffect(() => {
        if (endDate) {
            const today = new Date();
            const selectedDate = new Date(endDate);
            const diffTime = selectedDate.getTime() - today.getTime();
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            setDayCount(diffDays.toString());
        }
    }, [endDate]);

    useEffect(() => {
        if (dayCount !== "") {
            const today = new Date();
            today.setDate(today.getDate() + Number(dayCount));
            setEndDate(today.toISOString().split("T")[0]);
        }
    }, [dayCount]);

    const handleCloseDialogWithClear = () => {
        handleClear();
        handleCloseDialog();
    };

    const handleClear = () => {
        setFileCount("0");
        setMembershipType("PRESALE_FIXED");
        setDayCount("0");
        setEndDate(todayStr);
        setLastModifiedDate(todayStr);
        setPaymentAmount("0");
        setUserInput("");
        setAddCarriedDaysFixed(false);
    };

    const changeAhtabotSubscriptionBillingTypeToChoosenTypeFromUi = () => {
        if (fileCount === "" || fileCount === " " || Number(fileCount) === 0) {
            toast.error(WARNING_EMPTY_FILE_COUNT_MSG, {
                position: toast.POSITION.TOP_CENTER,
            });
            return;
        } else if (Number(fileCount) < 500) {
            toast.error(WARNING_MIN_FILE_COUNT_MSG, {
                position: toast.POSITION.TOP_CENTER,
            });
            return;
        }

        let request = ({
            ...ahtapotRequestDto,
            subscriptionBillingTypeEnumValue: membershipType,
            ahtapotFileCount: fileCount,
            ahtapotValidIntervalEndDate: endDate,
            ahtapotValidIntervalEndDateTime: moment(endDate, 'YYYY-MM-DD').valueOf(),
            lastModifiedDate: lastModifiedDate,
            paymentAmount: parseTurkishDecimal(paymentAmount),
            paymentRemark: userInput,
            carriedOverDayCount: (membershipType === "PRESALE_FIXED" && !addCarriedDaysFixed) ? 0 : carriedOverDayCount
        });

        if (moment().valueOf() > request.ahtapotValidIntervalEndDateTime) {
            toast.warning(WARNING_BEFORE_DATE_MSG, {
                position: toast.POSITION.TOP_CENTER
            });
            return;
        }

        fetch(changeAhtabotSubscriptionBillingTypeToChoosenTypeFromUiUrl, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'ApiAuthorization': 'Bearer '.concat(cookies.subscriptionToken)
            },
            body: JSON.stringify(request)
        }).then(res => {
            if (res.ok) {
                if (membershipType === "PRESALE_YEAR") {
                    toast.success("Üyelik Tipi, Yıllık Abonelik Tipine Başarıyla Güncellendi.", {
                        position: toast.POSITION.TOP_CENTER
                    });
                } else if (membershipType === "PRESALE_QUARTER") {
                    toast.success("Üyelik Tipi, 3 Aylık Abonelik Tipine Başarıyla Güncellendi.", {
                        position: toast.POSITION.TOP_CENTER
                    });
                } else if (membershipType === "PRESALE_FIXED") {
                    toast.success("Üyelik Tipi, Sabit Abonelik Tipine Başarıyla Güncellendi.", {
                        position: toast.POSITION.TOP_CENTER
                    });
                } else {
                    toast.success("Üyelik Tipi Güncelleme İşlemi Başarılı.", {
                        position: toast.POSITION.TOP_CENTER
                    });
                }
                getDataTenantList();
                changeTenantId(selectionModel);
                return res.json();
            } else {
                if (membershipType === "PRESALE_YEAR") {
                    toast.error("Üyelik Tipi, Yıllık Abonelik Tipine Güncellenemedi. " + connectionErrorMessage, {
                        position: toast.POSITION.TOP_CENTER
                    });
                } else if (membershipType === "PRESALE_QUARTER") {
                    toast.error("Üyelik Tipi, 3 Aylık Abonelik Tipine Güncellenemedi. " + connectionErrorMessage, {
                        position: toast.POSITION.TOP_CENTER
                    });
                } else if (membershipType === "PRESALE_FIXED") {
                    toast.error("Üyelik Tipi, Sabit Abonelik Tipine Güncellenemedi. " + connectionErrorMessage, {
                        position: toast.POSITION.TOP_CENTER
                    });
                } else {
                    toast.error("Üyelik Tipi Güncelleme İşlemi Başarısız. " + connectionErrorMessage, {
                        position: toast.POSITION.TOP_CENTER
                    });
                }
            }
        });
        handleCloseDialogWithClear();
    };

    const rows = [
        {
            label: "Ahtabot İşlem Yapılacak Dosya Sayısı",
            value: fileCount,
            onChange: (e) => {
                const value = e.target.value;
                if (value === "") {
                    setFileCount("0");
                } else if (Number(value) >= 0 && Number(value) <= 2147483647) {
                    setFileCount(value);
                }
            },
            type: "number",
            inputProps: {
                min: 0,
                max: 2147483647,
                onKeyDown: (e) => {
                    if (e.key === "-" || e.key === "e") {
                        e.preventDefault();
                    }
                },
            },
        },
        {
            label: "Kalan Gün Sayısı",
            value: showFixedCarry ? String(fixedAdditionalDays) : dayCount,
            onChange: (e) => {
                const value = e.target.value;
                if (showFixedCarry) {
                    if (value === "") {
                        setDayCount(String(carriedOverDayCount));
                    } else if (Number(value) >= 0 && Number(value) <= 9999999) {
                        setDayCount(String(carriedOverDayCount + Number(value)));
                    }
                } else if (value === "") {
                    setDayCount("0");
                } else if (Number(value) >= 0 && Number(value) <= 9999999) {
                    setDayCount(value);
                }
            },
            type: "number",
            disabled: membershipType !== "PRESALE_FIXED",
            startAdornmentText: showFixedCarry ? `${carriedOverDayCount} +` : undefined,
            helperText: showFixedCarry ? `Toplam: ${fixedTotalDays} gün` : undefined,
            inputProps: {
                min: 0,
                max: 9999999,
                onKeyDown: (e) => {
                    if (e.key === "-" || e.key === "e") {
                        e.preventDefault();
                    }
                },
            },
        },
        {
            label: "Üyelik Bitiş Tarihi",
            value: endDate,
            onChange: (e) => {
                const newDate = e.target.value;
                if (showFixedCarry && newDate) {
                    const todayDate = new Date();
                    const selected = new Date(newDate);
                    const diffDays = Math.ceil((selected.getTime() - todayDate.getTime()) / (1000 * 60 * 60 * 24));
                    if (diffDays < carriedOverDayCount) {
                        toast.info(`Bitiş tarihi, devredilecek olan ${carriedOverDayCount} günün minimum denk geldiği tarihin altına/öncesine ayarlanamaz.`, {
                            position: toast.POSITION.TOP_CENTER,
                        });
                        const minDate = new Date();
                        minDate.setDate(minDate.getDate() + carriedOverDayCount);
                        setEndDate(minDate.toISOString().split("T")[0]);
                        return;
                    }
                }
                setEndDate(newDate);
            },
            type: "date",
            disabled: membershipType !== "PRESALE_FIXED",
            inputProps: {
                min: todayStr,
            },
        },
        {
            label: "Son Güncelleme Tarihi",
            value: lastModifiedDate,
            onChange: (e) => setLastModifiedDate(e.target.value),
            type: "date"
        },
        {
            label: "Ödeme Ücret",
            value: paymentAmount,
            onChange: (e) => {
                if (e.target.value === "" || e.target.value === " ") {
                    setPaymentAmount("0");
                } else {
                    setPaymentAmount(e.target.value);
                }
            },
            type: "money"
        },
        {
            label: "Açıklama",
            value: userInput,
            onChange: (e) => setUserInput(e.target.value),
            type: "text"
        },
    ];

    function parseTurkishDecimal(input) {
        if (!input) return 0;
        const normalized = input.replace(/\./g, "").replace(",", ".");
        const number = parseFloat(normalized);
        return isNaN(number) ? 0 : number;
    }


    return (
        <Dialog
            open={openDialog}
            onClose={handleCloseDialogWithClear}
            maxWidth="xs"
            PaperProps={{
                style: {
                    border: "1px solid #a4a4ff",
                    borderRadius: 10,
                },
            }}
        >
            <DialogTitle
                sx={{
                    fontWeight: "bold",
                    fontSize: "24px",
                    padding: "8px 12px",
                    color: "#0000ee",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                Üyelik Tipi Güncelleme
                <IconButton
                    aria-label="close"
                    onClick={handleCloseDialogWithClear}
                    sx={{color: "#888"}}
                >
                    <CloseIcon/>
                </IconButton>
            </DialogTitle>

            <DialogContent sx={{padding: "8px 10px 0 12px"}}>
                <TextField
                    select
                    label="Üyelik Tipi"
                    variant="outlined"
                    value={membershipType}
                    onChange={(e) => setMembershipType(e.target.value)}
                    fullWidth
                    size="small"
                    sx={{
                        mt: 1,
                        '& label': {
                            color: '#1e88e5',
                            fontSize: '14px',
                        },
                        '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                                borderColor: '#1e88e5',
                            },
                            '&:hover fieldset': {
                                borderColor: '#1565c0',
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: '#1565c0',
                            },
                        },
                    }}
                >
                    <MenuItem value="PRESALE_FIXED">Sabit Abonelik</MenuItem>
                    <MenuItem value="PRESALE_QUARTER">3 Aylık Abonelik</MenuItem>
                    <MenuItem value="PRESALE_YEAR">Yıllık Abonelik</MenuItem>
                </TextField>

                {canCarryOver && carriedOverDayCount > 0 && (
                    <Box sx={{
                        mt: 1,
                        p: 1,
                        backgroundColor: "#e3f2fd",
                        border: "1px solid #90caf9",
                        borderRadius: 1,
                        fontSize: "12px",
                        color: "#0d47a1",
                    }}>
                        {isFixed ? (
                            <label style={{
                                display: "flex",
                                alignItems: "center",
                                margin: 0,
                                cursor: "pointer",
                                fontSize: "12px",
                                color: "#0d47a1",
                            }}>
                                <input
                                    type="checkbox"
                                    checked={addCarriedDaysFixed}
                                    onChange={(e) => setAddCarriedDaysFixed(e.target.checked)}
                                    style={{marginRight: 6, cursor: "pointer"}}
                                />
                                Aktif üyelikten kalan {carriedOverDayCount} gün yeni üyeliğe ilave edilsin.
                            </label>
                        ) : (
                            <>İşlem sonrası, aktif üyelikten kalan {carriedOverDayCount} gün yeni üyeliğe ilave edilecektir.</>
                        )}
                    </Box>
                )}

                <Table size="small" sx={{mt: 1}}>
                    <TableBody>
                        {rows.map((row, index) => (
                            <TableRow
                                key={index}
                                sx={{
                                    backgroundColor: index % 2 === 0 ? "#f1f1f1" : "#ffffff",
                                }}
                            >
                                <TableCell
                                    sx={{
                                        fontWeight: "bold",
                                        fontSize: "12px",
                                        whiteSpace: "nowrap",
                                        width: "50%",
                                        padding: "8px",
                                    }}
                                >
                                    {row.label}
                                </TableCell>
                                <TableCell sx={{padding: "8px", position: "relative"}}>
                                    <Box sx={{position: "relative"}}>
                                        {row.type === "money" ? (
                                            <NumberFormat
                                                customInput={TextField}
                                                fullWidth
                                                size="small"
                                                value={row.value.toString()}
                                                thousandSeparator="."
                                                decimalSeparator=","
                                                decimalScale={2}
                                                fixedDecimalScale={true}
                                                allowNegative={false}
                                                onChange={row.onChange}
                                                InputProps={{
                                                    endAdornment: (
                                                        <span style={{
                                                            marginLeft: 1,
                                                            fontSize: "13px",
                                                            color: "#757575",
                                                            whiteSpace: "nowrap"
                                                        }}>TL</span>
                                                    ),
                                                    style: {
                                                        textAlign: "right",
                                                        fontSize: "13px"
                                                    },
                                                }}
                                                disabled={row.disabled}
                                                sx={{
                                                    backgroundColor: row.disabled ? "#d3d3d3" : "#ffffff",
                                                    "& .MuiInputBase-input": {
                                                        color: row.disabled ? "#9e9e9e" : "inherit",
                                                    },
                                                    "& .MuiOutlinedInput-root": {
                                                        "& fieldset": {
                                                            padding: "0px 80px",
                                                        },
                                                        borderColor: row.disabled ? "#bdbdbd" : "#1e88e5",
                                                    },
                                                    '&:hover .MuiOutlinedInput-root': {
                                                        borderColor: row.disabled ? "#bdbdbd" : "#1565c0",
                                                    },
                                                    '&.Mui-focused .MuiOutlinedInput-root': {
                                                        borderColor: row.disabled ? "#bdbdbd" : "#1565c0",
                                                    },
                                                }}
                                            />) : (<TextField
                                            type={row.type}
                                            fullWidth
                                            size="small"
                                            value={row.type === "money" ? `₺${row.value}` : row.value}
                                            onChange={row.onChange}
                                            disabled={row.disabled}
                                            InputProps={row.startAdornmentText ? {
                                                startAdornment: (
                                                    <span style={{
                                                        fontSize: "13px",
                                                        color: "#9e9e9e",
                                                        whiteSpace: "nowrap",
                                                        marginRight: 4,
                                                    }}>{row.startAdornmentText}</span>
                                                ),
                                            } : undefined}
                                            inputProps={{
                                                style: {textAlign: "right", fontSize: "13px"},
                                                ...row.inputProps,
                                            }}
                                            sx={{
                                                backgroundColor: row.disabled ? "#d3d3d3" : "#ffffff",
                                                "& .MuiInputBase-input": {
                                                    color: row.disabled ? "#9e9e9e" : "inherit",
                                                },
                                                "& .MuiOutlinedInput-root": {
                                                    "& fieldset": {
                                                        padding: "0px 80px",
                                                    },
                                                    borderColor: row.disabled ? "#bdbdbd" : "#1e88e5",
                                                },
                                                '&:hover .MuiOutlinedInput-root': {
                                                    borderColor: row.disabled ? "#bdbdbd" : "#1565c0",
                                                },
                                                '&.Mui-focused .MuiOutlinedInput-root': {
                                                    borderColor: row.disabled ? "#bdbdbd" : "#1565c0",
                                                },
                                            }}
                                        />)}{row.label === "Üyelik Bitiş Tarihi" && row.disabled && (
                                        <CalendarTodayIcon
                                            sx={{
                                                position: "absolute",
                                                right: "16px",
                                                top: "51%",
                                                transform: "translateY(-51%)",
                                                fontSize: "16px",
                                                color: "#9e9e9e",
                                            }}
                                        />
                                    )}
                                        {row.helperText && (
                                            <Box sx={{
                                                fontSize: "11px",
                                                color: "#757575",
                                                textAlign: "right",
                                                mt: "2px",
                                            }}>
                                                {row.helperText}
                                            </Box>
                                        )}
                                    </Box>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </DialogContent>

            <DialogActions
                sx={{
                    padding: "10px 12px",
                    justifyContent: "flex-end",
                }}
            >
                <Box sx={{display: 'flex', gap: '5px'}}>
                    <Button variant="secondary" onClick={handleClear}>
                        Temizle
                    </Button>
                    <Button
                        variant="primary"
                        onClick={() =>
                            changeAhtabotSubscriptionBillingTypeToChoosenTypeFromUi()
                        }
                    >
                        Kaydet
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    );
}

export default MembershipModalDialog;